import React from 'react';

import './styles.css';

/*
 * Esqueleto com brilho: mostra o formato do conteúdo enquanto os dados não
 * chegam, no lugar da tela de carregamento (MyLoadingOverlay). Só para
 * carregar dados; salvar, excluir e exportar continuam com o MyLoadingOverlay,
 * que bloqueia a tela contra clique duplo.
 */

// Larguras variadas, para as linhas não parecerem uma grade
const WIDTHS = ['85%', '60%', '75%', '50%', '90%', '65%'];

// Um bloco: `width` e `height` em qualquer medida CSS
export function SkeletonBlock({ width = '100%', height, className = '' }) {
  return (
    <span
      className={`fdr-skeleton ${className}`}
      style={{ width, height }}
      aria-hidden="true"
    />
  );
}

// Linhas de tabela para pôr dentro do <tbody> enquanto a lista carrega
export function SkeletonTableRows({ rows = 10, columns }) {
  return (
    <>
      {Array.from({ length: rows }, (_, row) => (
        <tr key={row} className="fdr-skeleton-row" aria-hidden="true">
          {Array.from({ length: columns }, (__, col) => (
            <td key={col}>
              <SkeletonBlock
                width={col === 0 ? '1rem' : WIDTHS[(row + col) % WIDTHS.length]}
              />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}

// Ficha carregando: vai como primeiro filho do <Form>, que recebe a classe
// de skeletonFormClass(). O formulário fica montado e invisível (os campos
// recebem os dados normalmente) e os campos-esqueleto o cobrem
export function SkeletonForm({ fields = 24 }) {
  return (
    <div className="fdr-skeleton-cover" aria-hidden="true">
      {Array.from({ length: fields }, (_, field) => (
        <div key={field}>
          <SkeletonBlock
            width={field % 3 === 0 ? '35%' : '25%'}
            className="mb-2"
          />
          <SkeletonBlock className="fdr-skeleton-field" />
        </div>
      ))}
    </div>
  );
}

export const skeletonFormClass = loading =>
  loading ? 'fdr-skeleton-loading' : undefined;

export default SkeletonBlock;
